import { ShareIcon } from '@heroicons/react/outline'
import {
  GUESS_DISTRIBUTION_TEXT,
  SHARE_TEXT,
  STATISTICS_TITLE,
} from '../../constants/strings'
import { GameStats } from '../../lib/localStorage'
import { shareStatus } from '../../lib/share'
import { Histogram } from '../stats/Histogram'
import { StatBar } from '../stats/StatBar'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
  solution: string
  guesses: string[]
  gameStats: GameStats
  isLatestGame: boolean
  isGameLost: boolean
  isGameWon: boolean
  handleShareToClipboard: () => void
  handleShareFailure: () => void
  isHardMode: boolean
  isDarkMode: boolean
  isHighContrastMode: boolean
  numberOfGuessesMade: number
  solutionGameDate: Date
  tomorrow: number
}

export const StatsModal = ({
  isOpen,
  handleClose,
  solution,
  guesses,
  gameStats,
  isLatestGame,
  isGameLost,
  isGameWon,
  handleShareToClipboard,
  handleShareFailure,
  isHardMode,
  isDarkMode,
  isHighContrastMode,
  numberOfGuessesMade,
  solutionGameDate,
}: Props) => {
  // Determine title based on game state
  const title = isGameWon ? 'YOU WON! 🎉' : isGameLost ? 'GAME OVER' : STATISTICS_TITLE

  if (gameStats.totalGames <= 0) {
    return (
      <BaseModal
        title={title}
        isOpen={isOpen}
        handleClose={handleClose}
      >
        <StatBar gameStats={gameStats} />
      </BaseModal>
    )
  }
  return (
    <BaseModal
      title={title}
      isOpen={isOpen}
      handleClose={handleClose}
    >
      <div className="space-y-4">
        <StatBar gameStats={gameStats} />
        <h4 className="text-sm font-semibold uppercase tracking-wider text-slate-400">
          {GUESS_DISTRIBUTION_TEXT}
        </h4>
        <Histogram
          isLatestGame={isLatestGame}
          gameStats={gameStats}
          isGameWon={isGameWon}
          numberOfGuessesMade={numberOfGuessesMade}
        />
        {(isGameLost || isGameWon) && (
          <div className="border-t border-slate-200 pt-4">
            <button
              type="button"
              className="inline-flex w-full items-center justify-center rounded-pill border border-transparent bg-gradient-to-r from-clash-blue to-blue-400 px-4 py-2 text-center text-sm font-medium text-white shadow-md hover:shadow-lg hover:from-blue-500 hover:to-blue-300 focus:outline-none focus:ring-2 focus:ring-clash-blue focus:ring-offset-2 sm:text-base transition-all"
              onClick={() => {
                shareStatus(
                  solution,
                  guesses,
                  isGameLost,
                  isHardMode,
                  isDarkMode,
                  isHighContrastMode,
                  handleShareToClipboard,
                  handleShareFailure,
                  solutionGameDate
                )
              }}
            >
              <ShareIcon className="mr-2 h-6 w-6 cursor-pointer dark:stroke-white" />
              {SHARE_TEXT}
            </button>
          </div>
        )}
      </div>
    </BaseModal>
  )
}
